import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-no-stock-dialog',
  templateUrl: './no-stock-dialog.component.html',
  styleUrls: ['./no-stock-dialog.component.scss'],
})
export class NoStockDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<NoStockDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {}

  ngOnInit() {}

  cancelDialog() {
    this.dialogRef.close(false);
  }

  confirm() {
    this.dialogRef.close();
  }
}
